export const getAuthHeaders = () => {
  const sessionToken = localStorage.getItem('session_token');
  const headers = {
    'Content-Type': 'application/json',
  };

  if (sessionToken) {
    headers['X-Session-Token'] = sessionToken;
  }

  return headers;
};